import { ManagePlanQuantityStepper } from "./ManagePlanQuantityStepper";
import { ManagePlanUsageBar } from "./ManagePlanUsageBar";
import {
  MOCK_MANAGE_PLAN_BUILDER_SEAT_PRICE_ANNUAL_PER_MONTH_USD,
  MOCK_MANAGE_PLAN_BUILDER_SEAT_PRICE_MONTHLY_USD,
} from "./mockData";
import type { BillingInterval } from "store/slices/reduxApi/billing";

type ManagePlanSeatPanelProps = {
  billingInterval: BillingInterval;
  currentBuilderSeats: number;
  currentBuilderSeatUsage: number;
  builderSeatCountUnavailable?: boolean;
  builderSeats: number;
  onBuilderSeatsChange: (value: number) => void;
};

function formatUsd(amount: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}

function UsersIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-4 w-4 text-gray-500"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
      <path d="M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function ManagePlanSeatPanel({
  billingInterval,
  currentBuilderSeats,
  currentBuilderSeatUsage,
  builderSeatCountUnavailable = false,
  builderSeats,
  onBuilderSeatsChange,
}: ManagePlanSeatPanelProps) {
  const builderSeatPrice =
    billingInterval === "annual"
      ? MOCK_MANAGE_PLAN_BUILDER_SEAT_PRICE_ANNUAL_PER_MONTH_USD * 12
      : MOCK_MANAGE_PLAN_BUILDER_SEAT_PRICE_MONTHLY_USD;
  const intervalSuffix = billingInterval === "annual" ? "/yr" : "/mo";

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50/60 px-4 py-3">
        <UsersIcon />
        <div className="text-sm font-semibold text-gray-950">AI Builders</div>
      </div>
      <div className="px-4 py-4">
        <div className="space-y-4">
          <div>
            <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-gray-400">
              Current plan
            </div>
            <div className="mt-1 text-sm font-semibold text-gray-950">
              {currentBuilderSeats} AI Builders at {formatUsd(builderSeatPrice)}
              {intervalSuffix} each
            </div>
          </div>

          <ManagePlanUsageBar
            used={currentBuilderSeatUsage}
            total={builderSeats}
            colorClassName="bg-sky-500"
          />

          <div className="my-3 h-px bg-gray-200" />
          <span className="block text-sm text-gray-500">
            Adjust AI Builders
          </span>
          <div className="w-full">
            <ManagePlanQuantityStepper
              value={builderSeats}
              min={currentBuilderSeatUsage}
              disabled={builderSeatCountUnavailable}
              onChange={onBuilderSeatsChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
